export default __webpack_public_path__ + "static/media/browsers.f51237e0.png";